// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreCart = (client) => ({
    /**
     * `POST /store/carts/:id/payment-session/razorpay/confirm`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdPaymentSessionRazorpayConfirmCreate
     * @source apps/backend/src/api/store/carts/[id]/payment-session/razorpay/confirm/route.ts
     */
    confirmPaymentSessionRazorpay: (id, body, query, headers) => client.fetch(buildPath("/store/carts/:id/payment-session/razorpay/confirm", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/carts/:id/approvals`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/carts/[id]/approvals/route.ts
     */
    createApproval: (id, body, query, headers) => client.fetch(buildPath("/store/carts/:id/approvals", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/carts/:id/sellers/:seller_id/line-items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdSellersSellerIdLineItemsCreate
     * @source packages/modules/b2c-core/src/api/store/carts/[id]/sellers/[seller_id]/line-items/route.ts
     */
    createSellersLineItem: (id, sellerId, body, query, headers) => client.fetch(buildPath("/store/carts/:id/sellers/:seller_id/line-items", [id, sellerId]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/carts/:id/sellers/:seller_id/line-items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdSellersSellerIdLineItemsDelete
     * @source packages/modules/b2c-core/src/api/store/carts/[id]/sellers/[seller_id]/line-items/route.ts
     */
    deleteSellersLineItem: (id, sellerId, body, query, headers) => client.fetch(buildPath("/store/carts/:id/sellers/:seller_id/line-items", [id, sellerId]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /store/carts/:id/shipping-methods`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdShippingMethodsDelete
     * @source packages/modules/b2c-core/src/api/store/carts/[id]/shipping-methods/route.ts
     */
    deleteShippingMethod: (id, body, query, headers) => client.fetch(buildPath("/store/carts/:id/shipping-methods", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /store/carts/:id/sellers/:seller_id/line-items/status`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdSellersSellerIdLineItemsStatusRetrieve
     * @source packages/modules/b2c-core/src/api/store/carts/[id]/sellers/[seller_id]/line-items/status/route.ts
     */
    listSellersLineItemsStatus: (id, sellerId, query, headers) => client.fetch(buildPath("/store/carts/:id/sellers/:seller_id/line-items/status", [id, sellerId]), { method: "GET", query, headers }),
    /**
     * `PATCH /store/carts/:id/share/:shareId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId PatchStoreCartShareById
     * @source apps/backend/src/api/store/carts/[id]/share/[shareId]/route.ts
     */
    patchUpdateShare: (id, shareId, body, query, headers) => client.fetch(buildPath("/store/carts/:id/share/:shareId", [id, shareId]), { method: "PATCH", body, query, headers }),
    /**
     * `GET /store/carts/:id/share/:shareId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId GetStoreCartShareById
     * @source apps/backend/src/api/store/carts/[id]/share/[shareId]/route.ts
     */
    retrieveShare: (id, shareId, query, headers) => client.fetch(buildPath("/store/carts/:id/share/:shareId", [id, shareId]), { method: "GET", query, headers }),
    /**
     * `GET /store/carts/:id/terms-acceptance`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdTermsAcceptanceRetrieve
     * @source apps/backend/src/api/store/carts/[id]/terms-acceptance/route.ts
     */
    retrieveTermsAcceptance: (id, query, headers) => client.fetch(buildPath("/store/carts/:id/terms-acceptance", [id]), { method: "GET", query, headers }),
    /**
     * `POST /store/carts/:id/line-items/bulk`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdLineItemsBulkCreate
     * @source packages/modules/b2c-core/src/api/store/carts/[id]/line-items/bulk/route.ts
     */
    updateLineItemsBulk: (id, body, query, headers) => client.fetch(buildPath("/store/carts/:id/line-items/bulk", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/carts/:id/share`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdShareCreate
     * @source apps/backend/src/api/store/carts/[id]/share/route.ts
     */
    updateShare: (id, body, query, headers) => client.fetch(buildPath("/store/carts/:id/share", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/carts/:id/terms-acceptance`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartsIdTermsAcceptanceCreate
     * @source apps/backend/src/api/store/carts/[id]/terms-acceptance/route.ts
     */
    updateTermsAcceptance: (id, body, query, headers) => client.fetch(buildPath("/store/carts/:id/terms-acceptance", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=carts.js.map